module.exports = "/_next/static/images/caravan-cf62626180c61b669add7957a717ea50.svg";